( function() {

	var $ 			= require('jquery');
	var menu 		= $('.menu-fold');
	var sub_menu 	= $('.menu-fold__sub-menu');
	/**
	 * Toggle fly-out navigation
	 */
	$('.menu-toggle').on('click', function(event) {
		$('.menu-fold').addClass('menu-fold--expanded');
	});

	/**
	 * Closes fly-out navigation
	 */
	$('.menu-fold__item--close').on('click', function(event) {
		event.preventDefault();
		menu.removeClass('menu-fold--expanded');
	});

	/**
	 * Expands sub-menu navigation
	 * TODO: Simplify
	 */
	 $('.menu-fold__item--parent > a').on('click', function(event) {
		 event.preventDefault();
		 console.log('test');
		 if ( $(this).parent().find(sub_menu).hasClass('menu-fold__sub-menu--expanded')) {
			 $(this).parent().find(sub_menu).removeClass('menu-fold__sub-menu--expanded');
			 $(this).parent().removeClass('menu-fold__item--expanded');
		 } else {
			 $(this).parent().find(sub_menu).addClass('menu-fold__sub-menu--expanded');
			 $(this).parent().addClass('menu-fold__item--expanded');
			 $(this).parent().siblings().find('.menu-fold__item--expanded').removeClass('menu-fold__item--expanded');
		 }

		 $(this).parent().siblings().find('.menu-fold__sub-menu--expanded').removeClass('menu-fold__sub-menu--expanded');
		 $(this).parent().siblings().removeClass('menu-fold__sub-menu--dark');

	 });


})();
